<div class="table-responsive animated fadeIn slow">
    <div>
        <h2 style="text-align: center;" class="titulo">LISTADO DE APOYOS PARA BECAS PAGADOS</h2>
    </div>

    <div class="table-wrapper">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">
            <thead>
                <tr>
                    <th style="text-align: center;">Número de empleado</th>
                    <th style="text-align: center;">Nombre del empleado</th>
                    <th style="text-align: center;">Número de factura</th>
                    <th style="text-align: center;">Total factura</th>
                    <th style="text-align: center;">Importe</th>
                    <th style="text-align: center;">Emisor</th>
                    <th style="text-align: center;">Plantel</th>
                    <th style="text-align: center;">Estatus</th>
                    <th style="text-align: center;">Ver</th>
                    <th style="text-align: center;">Subir XML</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let inventarios of becas">
                    <tr>
                        <td>{{inventarios.numempleado}}</td>
                        <td>{{inventarios.nombre}} {{inventarios.appaterno}} {{inventarios.apmaterno}}</td>
                        <td>{{inventarios.no_factura}}</td>
                        <td>{{inventarios.total_factura}}</td>
                        <td>{{inventarios.importe}}</td>
                        <td>{{inventarios.emisor}}</td>
                        <td>{{inventarios.nombreplantel}}</td>
                        <td style="text-align:center; vertical-align: middle;">
                            <span *ngIf="inventarios.pagado == 0" class="estatus-registrado">Registrado</span>
                            <span *ngIf="inventarios.pagado == 1" class="estatus-pagado">Pagado</span>
                            <span *ngIf="inventarios.pagado == 3" class="estatus-pendiente">Pendiente</span>

                        </td>




                        <td>
                            <button class="btn-icon ver" data-toggle="modal" data-target="#Verbecas" (click)="verbecasss(inventarios.idbecas)">
            <i class="fas fa-eye"></i>
          </button>
                        </td>
                        <td class="td-center">
                            <button *ngIf="inventarios.xmlsubido == null" class="btn-icon ver" data-toggle="modal" data-target="#Verbeca" (click)="abrirAgregarXML(inventarios.idbecas)">
  <i class="fas fa-file-import"></i>
</button>
                            <button *ngIf="inventarios.xmlsubido == 1" class="estatus-conxml" data-toggle="modal" data-target="#VERXML" (click)="verXMLsss(inventarios.folio_sat)">

  Registrado

</button>
                        </td>

                    </tr>
                </ng-container>
            </tbody>
        </table>

    </div>
</div>

<div class="modal fade bd-example-modal-lg" id="Verbecas" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">

            <!-- HEADER -->
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">VER APOYO DE BECAS</h2>
            </div>

            <!-- BODY -->
            <div class="modal-body-asig">
                <div class="container-asig">

                    <!-- SECCIÓN 1 -->
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Número de empleado:</label>
                            <select class="form-control form-control-asig" [(ngModel)]="becasinfo.numempleado" (change)="actualizarNombreEmpleado()" disabled>
                <option value="" disabled selected>Selecciona un empleado</option>
                <option *ngFor="let emp of empleado" [value]="emp.numpersonal">
                  {{emp.numpersonal}}
                </option>
              </select>
                        </div>

                        <div class="col col-lg-8">
                            <label class="label-asig">Nombre del empleado:</label>
                            <input type="text" class="form-control form-control-asig" [value]="nombreEmpleadoSeleccionado" disabled>
                        </div>
                    </div>
                    <br>

                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Tipo de personal:</label>
                            <select class="form-control form-control-asig" [(ngModel)]="becasinfo.tipopersonal" disabled>
  <option value="SINDICALIZADO">SINDICALIZADO</option>
  <option value="NO SINDICALIZADO">NO SINDICALIZADO</option>
</select>

                        </div>
                        <div class="col col-lg-8">
                            <label class="label-asig">Categoría:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.categoria" disabled>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-12">
                            <label class="label-asig">Folio SAT:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.folio_sat" disabled>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">No. factura:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.no_factura" disabled>
                        </div>
                        <div class="col col-lg-4">
                            <label class="label-asig">Importe:</label>
                            <input type="number" class="form-control form-control-asig" [(ngModel)]="becasinfo.total_factura" disabled>
                        </div>

                        <div class="col col-lg-4">
                            <label class="label-asig">Importe 50%:</label>
                            <input type="text" class="form-control form-control-asig" [value]="becasinfo.importe | number:'1.2-2'" readonly disabled>
                        </div>


                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-9">
                            <label class="label-asig">Emisor:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.emisor" disabled>
                        </div>
                        <div class="col col-lg-3">
                            <label class="label-asig">Fecha factura:</label>
                            <input type="date" class="form-control form-control-asig" [(ngModel)]="becasinfo.fecha_factura" disabled>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-12">
                            <label class="label-asig">Observación:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.observacion" disabled>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Fecha pago en nomina:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.fecha_pagonomina" disabled>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">No. oficio:</label>
                            <input type="text" class="form-control form-control-asig" [(ngModel)]="becasinfo.no_oficio" disabled>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-4">
                            <label class="label-asig">Fecha oficio:</label>
                            <input type="date" class="form-control form-control-asig" [(ngModel)]="becasinfo.fecha_oficio" disabled>
                        </div>

                        <div class="col col-lg-8">

                            <label class="label-asig">Quincena a pagar:</label>
                            <select class="form-control form-control-asig" [(ngModel)]="becasinfo.quincena_pago" disabled>
        <option value="1A. QNA DE ENERO">1A. QNA DE ENERO</option>
        <option value="2A. QNA DE ENERO">2A. QNA DE ENERO</option>

        <option value="1A. QNA DE FEBRERO">1A. QNA DE FEBRERO</option>
        <option value="2A. QNA DE FEBRERO">2A. QNA DE FEBRERO</option>

        <option value="1A. QNA DE MARZO">1A. QNA DE MARZO</option>
        <option value="2A. QNA DE MARZO">2A. QNA DE MARZO</option>

        <option value="1A. QNA DE ABRIL">1A. QNA DE ABRIL</option>
        <option value="2A. QNA DE ABRIL">2A. QNA DE ABRIL</option>

        <option value="1A. QNA DE MAYO">1A. QNA DE MAYO</option>
        <option value="2A. QNA DE MAYO">2A. QNA DE MAYO</option>

        <option value="1A. QNA DE JUNIO">1A. QNA DE JUNIO</option>
        <option value="2A. QNA DE JUNIO">2A. QNA DE JUNIO</option>

        <option value="1A. QNA DE JULIO">1A. QNA DE JULIO</option>
        <option value="2A. QNA DE JULIO">2A. QNA DE JULIO</option>

        <option value="1A. QNA DE AGOSTO">1A. QNA DE AGOSTO</option>
        <option value="2A. QNA DE AGOSTO">2A. QNA DE AGOSTO</option>

        <option value="1A. QNA DE SEPTIEMBRE">1A. QNA DE SEPTIEMBRE</option>
        <option value="2A. QNA DE SEPTIEMBRE">2A. QNA DE SEPTIEMBRE</option>

        <option value="1A. QNA DE OCTUBRE">1A. QNA DE OCTUBRE</option>
        <option value="2A. QNA DE OCTUBRE">2A. QNA DE OCTUBRE</option>

        <option value="1A. QNA DE NOVIEMBRE">1A. QNA DE NOVIEMBRE</option>
        <option value="2A. QNA DE NOVIEMBRE">2A. QNA DE NOVIEMBRE</option>

        <option value="1A. QNA DE DICIEMBRE">1A. QNA DE DICIEMBRE</option>
        <option value="2A. QNA DE DICIEMBRE">2A. QNA DE DICIEMBRE</option>
    </select>

                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-5">
                            <label class="label-asig">Periodo:</label>
                            <select class="form-control" class="form-control-asig disabled-asig" [(ngModel)]="becasinfo.periodo" disabled>
                     <ng-container *ngFor="let periodos of periodoss">
                      <option *ngIf="periodos.esactivo==true" [value]="periodos.idperiodo" > {{periodos.periodo}}  {{periodos.ciclo}}</option>
                      </ng-container>
                           </select>
                        </div>
                        <div class="col col-lg-3"></div>
                        <div class="col col-lg-4"></div>
                    </div>

                    <br>
                </div>
            </div>

            <div class="modal-footer-asig">
                <button type="button" class="btn-cancelar" data-dismiss="modal" (click)="resetBeca()">Cerrar</button>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="Agrexml" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">AGREGAR XML</h2>
            </div>

            <div class="modal-body-asig">
                <div class="container-asig">
                    <div class="row mt-3">
                        <div class="col col-lg-12">
                            <b><label for="xmlFile">Seleccionar archivo XML:</label></b>
                            <input type="file" id="xmlFile" (change)="onFileSelected($event)" accept=".xml" class="form-control">
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer-asig">
                <button type="button" class="btn-cancelar" (click)="cerrarAgregarXML()">Cerrar</button>
            </div>

        </div>
    </div>
</div>

<!-- MODAL PREVIEW / EDITAR XML -->
<div class="modal fade" id="previewXML" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">PREVISUALIZAR Y EDITAR XML</h2>
            </div>

            <div class="modal-body-asig">

                <form #f="ngForm">

                    <!-- RESUMEN -->
                    <div class="row">

                        <div class="col-md-3">
                            <label>Folio:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.folio" name="folio" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Subtotal:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.subtotal" name="subtotal" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Descuento:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.descuento" name="descuento" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Total:</label>
                            <div class="input-group">
                                <input class="form-control fw-bold" [(ngModel)]="xmlPreview.total" name="total" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.total)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- IMPUESTOS -->
                    <div class="row mt-3">

                        <div class="col-md-4">
                            <label>IVA 16%:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.iva16" name="iva16" disabled>
                        </div>

                        <div class="col-md-4">
                            <label>Base 0%:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.base0" name="base0" disabled>
                        </div>

                        <div class="col-md-4">
                            <label>ISR:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.isr" name="isr" disabled>
                        </div>

                    </div>

                    <!-- EMISOR -->
                    <div class="row mt-4">

                        <div class="col-md-6">
                            <label>RFC Emisor:</label>
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="xmlPreview.rfc_emisor" name="rfc_emisor" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.rfc_emisor)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label>Nombre Emisor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_emisor" name="nombre_emisor">
                        </div>

                    </div>

                    <!-- RECEPTOR -->
                    <div class="row mt-3">

                        <div class="col-md-6">
                            <label>RFC Receptor:</label>
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="xmlPreview.rfc_receptor" name="rfc_receptor" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.rfc_receptor)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label>Nombre Receptor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_receptor" name="nombre_receptor">
                        </div>

                    </div>

                    <!-- TIMBRADO -->
                    <div class="row mt-3">

                        <div class="col-md-6">
                            <label>UUID:</label>
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="xmlPreview.uuid" name="uuid" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.uuid)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label>No. Certificado SAT:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.no_certificado_sat" name="no_certificado_sat" disabled>
                        </div>

                    </div>

                    <br>

                    <div class="text-right mb-3">
                        <button class="btn-verificar-sat" type="button" (click)="irASAT()">
                            Verificar en SAT
                        </button>
                    </div>

                </form>

            </div>

            <div class="modal-footer-asig">
                <button class="btn-guardar" type="button" (click)="confirmarXML()">
                    Confirmar y Guardar
                </button>

                <button class="btn-cancelar" type="button" (click)="cerrarPreviewXML()">
                    Cancelar
                </button>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="VERXML" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">VER XML</h2>
            </div>

            <div class="modal-body-asig">

                <form #f="ngForm">

                    <!-- RESUMEN -->
                    <div class="row">

                        <div class="col-md-3">
                            <label>Folio:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.folio" name="folio" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Subtotal:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.subtotal" name="subtotal" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Descuento:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.descuento" name="descuento" disabled>
                        </div>

                        <div class="col-md-3">
                            <label>Total:</label>
                            <div class="input-group">
                                <input class="form-control fw-bold" [(ngModel)]="xmlPreview.total" name="total" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.total)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- IMPUESTOS -->
                    <div class="row mt-3">

                        <div class="col-md-4">
                            <label>IVA 16%:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.iva16" name="iva16" disabled>
                        </div>

                        <div class="col-md-4">
                            <label>Base 0%:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.base0" name="base0" disabled>
                        </div>

                        <div class="col-md-4">
                            <label>ISR:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.isr" name="isr" disabled>
                        </div>

                    </div>

                    <!-- EMISOR -->
                    <div class="row mt-4">

                        <div class="col-md-6">
                            <label>RFC Emisor:</label>
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="xmlPreview.rfc_emisor" name="rfc_emisor" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.rfc_emisor)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label>Nombre Emisor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_emisor" name="nombre_emisor" disabled>
                        </div>

                    </div>

                    <!-- RECEPTOR -->
                    <div class="row mt-3">

                        <div class="col-md-6">
                            <label>RFC Receptor:</label>
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="xmlPreview.rfc_receptor" name="rfc_receptor" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.rfc_receptor)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label>Nombre Receptor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_receptor" name="nombre_receptor" disabled>
                        </div>

                    </div>

                    <!-- TIMBRADO -->
                    <div class="row mt-3">

                        <div class="col-md-6">
                            <label>UUID:</label>
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="xmlPreview.uuid" name="uuid" disabled>
                                <div class="input-group-append">
                                    <button class="btn-copiar" type="button" (click)="copiarTexto(xmlPreview.uuid)">
                                        Copiar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label>No. Certificado SAT:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.no_certificado_sat" name="no_certificado_sat" disabled>
                        </div>

                    </div>

                    <br>

                    <div class="text-right mb-3">
                        <button class="btn-verificar-sat" type="button" (click)="irASAT()">
                            Verificar en SAT
                        </button>
                    </div>

                </form>

            </div>

            <div class="modal-footer-asig">


                <button class="btn-cancelar" type="button" data-dismiss="modal">
    Cancelar
</button>
            </div>

        </div>
    </div>
</div>